// import Routing from 'routing';
import PonroyFilterGroup from './FilterGroup.vue';
import PonroyFilterCheckbox from './FilterCheckbox.vue';
import PonroyFilterTags from './FilterTags.vue';
import PonroyCart from './Cart.vue';
import PonroyCartItem from './CartItem.vue';
import PonroyCartAdd from './CartAdd.vue';
import PonroyCartReferenceCard from './CartReferenceCard.vue';
import PonroyCartQuantity from './CartQuantity.vue';
import PonroyProductGroup from './ProductGroup.vue';
import PonroyProductCard from './ProductCard.vue';
import PonroyProductCount from './ProductCount.vue';
import PonroyProductSort from './ProductSort.vue';
import PonroyCartWidget from './CartWidget.vue';
import PonroyCartWidgetItem from './CartWidgetItem.vue';
import PonroyProductPagination from './ProductPagination.vue';
import PonroyPagination from './Pagination.vue';
import PonroyCartSearch from './CartSearch.vue';
import PonroyProductReferenceCard from './ProductReferenceCard.vue';
import PonroyGiftGroup from './GiftGroup.vue';
import PonroyGiftCard from './GiftCard.vue';
import PonroyProductRecommendation from './ProductRecommendation.vue';
import PonroyCartRecommendation from './CartRecommendation.vue';
import PonroyCartSidebar from './CartSidebar.vue';

// ORDER
import PonroyOrderDelivery from './Order/OrderDelivery.vue';
import PonroyOrderShippingAddress from './Order/OrderShippingAddress.vue';
import PonroyOrderBillingAddress from './Order/OrderBillingAddress.vue';
import PonroyOrderCarrier from './Order/OrderCarrier.vue';
import PonroyOrderInputCarrier from './Order/OrderInputCarrier.vue';
import PonroyOrderInputShippingAddress from './Order/OrderInputShippingAddress.vue';
import PonroyOrderInputBillingAddress from './Order/OrderInputBillingAddress.vue';
import PonroyOrderInputSameAddress from './Order/OrderInputSameAddress.vue';
import PonroyOrderColissimo from './Order/OrderColissimo.vue';
import PonroyOrderInputColissimo from './Order/OrderInputColissimo.vue';
import PonroyOrderInputColissimoPoint from './Order/OrderInputColissimoPoint.vue';
import PonroyGoogleMap from './Order/GoogleMap.vue';
import PonroyOrderSubmit from './Order/OrderSubmit.vue';
import PonroyOrderAddressesModal from './Order/OrderAddressesModal.vue';

import PonroyCartSamples from './CartSamples.vue';

export default {
    PonroyFilterGroup,
    PonroyFilterCheckbox,
    PonroyFilterTags,
    PonroyCart,
    PonroyCartAdd,
    PonroyCartReferenceCard,
    PonroyCartQuantity,
    PonroyCartWidgetItem,
    PonroyCartItem,
    PonroyCartSamples,
    PonroyProductGroup,
    PonroyProductCard,
    PonroyProductReferenceCard,
    PonroyProductCount,
    PonroyProductSort,
    PonroyCartWidget,
    PonroyProductPagination,
    PonroyPagination,
    PonroyCartSearch,
    PonroyGiftGroup,
    PonroyGiftCard,
    PonroyProductRecommendation,
    PonroyCartRecommendation,
    PonroyCartSidebar,
    PonroyOrderDelivery,
    PonroyOrderShippingAddress,
    PonroyOrderBillingAddress,
    PonroyOrderCarrier,
    PonroyOrderInputCarrier,
    PonroyOrderInputShippingAddress,
    PonroyOrderInputBillingAddress,
    PonroyOrderInputSameAddress,
    PonroyOrderInputColissimoPoint,
    PonroyOrderColissimo,
    PonroyOrderInputColissimo,
    PonroyGoogleMap,
    PonroyOrderSubmit,
    PonroyOrderAddressesModal,
};



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/components/index.js